"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("../_internal/utils");
function sync(f, iterable) {
    var _a;
    var iterator = iterable[Symbol.iterator]();
    return _a = {
            next: function () {
                var _a = iterator.next(), done = _a.done, value = _a.value;
                if (done) {
                    return {
                        done: true,
                        value: undefined,
                    };
                }
                return {
                    done: false,
                    value: f(value),
                };
            }
        },
        _a[Symbol.iterator] = function () {
            return this;
        },
        _a;
}
function async(f, iterable) {
    var _a;
    var iterator = iterable[Symbol.asyncIterator]();
    return _a = {
            next: function (_concurrent) {
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    var _a, done, value;
                    var _b;
                    return tslib_1.__generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, iterator.next(_concurrent)];
                            case 1:
                                _a = _c.sent(), done = _a.done, value = _a.value;
                                if (done)
                                    return [2 /*return*/, { done: done, value: value }];
                                _b = {
                                    done: false
                                };
                                return [4 /*yield*/, f(value)];
                            case 2: return [2 /*return*/, (_b.value = _c.sent(),
                                    _b)];
                        }
                    });
                });
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
function map(f, iterable) {
    if (iterable === undefined) {
        return function (iterable) {
            return map(f, iterable);
        };
    }
    if ((0, utils_1.isIterable)(iterable)) {
        return sync(f, iterable);
    }
    if ((0, utils_1.isAsyncIterable)(iterable)) {
        return async(f, iterable);
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = map;
//# sourceMappingURL=map.js.map